{
  "it": {
    "inspiration_list": {
      "actions": {
        "cancel": "Annulla",
        "delete": "Elimina",
        "deleteMultiple": "Elimina...",
        "delete_cancel": "Annulla",
        "edit": "Modifica",
        "new": "Nuovo album fotografico",
        "save": "Salva",
        "submit": "Salva",
        "tickBoxesDeletion": "Selezioni le caselle dei file che desidera eliminare."
      },
      "attributes": {
        "name": "Nome"
      },
      "info": "Cosa desidera per la Sua nuova casa? Carichi le foto che La ispirano. Gli album Le permettono di organizzarle per argomento: cucina, bagno, mobili, ...",
      "labels": {
        "inspiration_list": "Liste di ispirazione",
        "inspirationlist": "Album d'ispirazione",
        "inspirations": "Ispirazioni",
        "noInspirationLists": "Nessuna lista di ispirazione ancora",
        "noInspirations": "Nessuna ispirazione ancora"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Crei album diversi per la Sua cucina, il Suo bagno o i Suoi mobili e carichi le foto che La ispirano.",
            "title": "Come decorerà la Sua nuova casa?"
          }
        }
      },
      "validation": {
        "needTitle": "Il titolo è obbligatorio",
        "selectInspirationList": "Selezioni almeno 1 lista di ispirazione"
      }
    }
  }
}
